// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Transactions = [
  {
    title: 'Ledger Approval',
    path: '/dashboard/manage/ledger_approval',
    icon: icon('company', 'png'),
    ShortName: 'LedgerApproval',
  },  
  {
    title: 'Order Approval',
    path: '/dashboard/manage/order_approval',
    icon: icon('company', 'png'),
    ShortName: 'OrderGeneration',
  },
  {
    title: 'Pre Booking',
    path: '/dashboard/manage/pre_booking',
    icon: icon('company', 'png'),
    ShortName: 'PreBooking',
  },
  // {
  //   title: 'Cargo Rate',
  //   path: '/dashboard/master/cargo_rate',
  //   icon: icon('company', 'png'),
  //   ShortName: 'CargoRate'
  // },
  {
    title: 'Unfinished Registration',
    path: '/dashboard/manage/signup_crm',
    icon: icon('company', 'png'),
    ShortName: 'SignupCRM'
  }, 
  // {
  //   title: 'Manage Pick Up',
  //   path: '/dashboard/manage/manage_pick_up',
  //   icon: icon('company', 'png'),
  //   ShortName: 'ManagePickUp',
  // },
];

export default Transactions;
